function initProductSearch() {
  $("#filter-toggle-button").click(function () {
    $(this).children().toggleClass("fa-sliders-h fa-times");
    $("#filter-toggle").slideToggle();
  });

  $("#sort-toggle-btn").click(function () {
    $(this)
      .find(".fa-chevron-up, .fa-chevron-down")
      .toggleClass("fa-chevron-up fa-chevron-down");
    $("#sort-toggle").slideToggle();
  });
}
